import { Breadcrumb, Button, Col, Row } from "react-bootstrap";
import Header from "./Header";
import "./Contact.css";
import contact from "../assets/images/contact.jpg";
import { createTheme, TextField, ThemeProvider } from "@mui/material";
import { useState } from "react";
import Footer from "./Footer";
import { ReactComponent as Email } from "../assets/images/email.svg";
import { ReactComponent as Location } from "../assets/images/location.svg";
import { ReactComponent as Phone } from "../assets/images/telephone.svg";
import { useNavigate } from "react-router-dom";

function ContactUs() {
   const navigate = useNavigate();
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.6)", 
            },
          },
        },
      },
      // Add this to ensure text color changes on focus
      MuiInputBase: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: "black", 
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: "rgba(0, 0, 0, 0.6)",
            },
          },
        },
      },
    },
  });
  const [formValues, setFormValues] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    console.log("Form Values:", formValues);
    setFormValues({
      fullName: "",
      email: "",
      phone: "",
      message: "",
    });
  };
  return (
    <>
      <div className="contact">
        <div style={{ height: "130px" }}>
          <Header />
        </div>
        <div className="banner text-center">
          <h2>Contact Us</h2>
          <p className="banner-text">
            Whether you’re looking for a technology partner, need help with your
            digital transformation, <br /> or just have a question our team is
            here to assist you.
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Breadcrumb style={{ color: "white" }} className="text-center mt-3">
              <Breadcrumb.Item className="item" onClick={()=>{navigate('/')}}>Home</Breadcrumb.Item>
              <Breadcrumb.Item className="item" href="" active>
                Contact Us
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
        <div className="container section text-center margin-top">
          <h2>Get in Touch With Us</h2>
          <p>
            We’re here for the long haul. Let's connect and build something
            great together.
          </p>
        </div>
        <div className="container mt-5">
          <Row className="d-flex justify-content-between align-items-center">
            <Col lg={6} md={12} sm={12} className="form">
              <div className="d-flex flex-column gap-4">
                <ThemeProvider theme={theme}>
                  <TextField
                    id="outlined-basic"
                    label="Full Name"
                    variant="outlined"
                    name="fullName"
                    value={formValues.fullName}
                    onChange={handleChange}
                  />
                  <TextField
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    name="email"
                    value={formValues.email}
                    onChange={handleChange}
                  />
                  <TextField
                    id="outlined-basic"
                    label="Phone"
                    variant="outlined"
                    name="phone"
                    value={formValues.phone}
                    onChange={handleChange}
                  />
                  <TextField
                    id="outlined-multiline"
                    label="Message"
                    variant="outlined"
                    multiline
                    rows={3}
                    fullWidth
                    name="message"
                    value={formValues.message}
                    onChange={handleChange}
                  />
                </ThemeProvider>
                <Button
                  className="mx-auto contact-button"
                  style={{ width: "50%" ,height:"45px"}}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12} sm={12} className="img-div ">
              <img src={contact} alt="" style={{ height: "500px" }} />
            </Col>
          </Row>
        </div>
        <div className="container margin-top mb-5 ">
          <Row className="d-flex justify-content-between ">
            <Col lg={6} md={12} sm={12}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.8559518685856!2d72.90711407587636!3d21.237559980573156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be045f1f1b56521%3A0x5058f2d570092430!2sBluestone!5e0!3m2!1sen!2sin!4v1747719111521!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
                loading="lazy"
                 title="Google Maps location of Bluestone"
              ></iframe>
            </Col>
            <Col lg={6} md={12} sm={12} className="d-flex flex-column gap-4 contact-div">
              <div className="d-flex gap-4 justify-content-center ">
                <div className="contact-icon">
                  <Location
                    style={{ height: "23px", width: "23px", fill: "white" }}
                  />
                </div>
                <div>
                  <h4>Location</h4>
                  <p>
                    204, Blue Stone Building, <br /> Shyamdham Chowk, surat, <br />
                    Gujrat.
                  </p>
                </div>
              </div>

              <div className="d-flex gap-4 justify-content-center">
                <div className="contact-icon">
                  <Email
                    style={{ height: "23px", width: "23px", fill: "white" }}
                  />
                </div>
                <div>
                  <h4>Phone</h4>
                  <p> contact@flora-infotech.com</p>
                </div>
              </div>
              <div className="d-flex gap-4 justify-content-center">
                <div className="contact-icon">
                  <Phone
                    style={{
                      height: "23px",
                      width: "23px",
                      fill: "white",
                      stroke: "white",
                    }}
                  />
                </div>
                <div>
                  <h4>Email</h4>
                  <p> contact@flora-infotech.com</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default ContactUs;
